export const slugifyCountry = (s) =>
  s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const COUNTRY_GUIDES = [
  {
    name: "India",
    flag: "🇮🇳",
    domestic: true,
    image: "https://images.unsplash.com/photo-1680084521816-cc1ad0433ceb?q=85&w=1200",
    tagline: "World-class institutes, affordable fees and booming job markets at home.",
    admissions: {
      type: "Entrance-based (no visa required)",
      exams: "JEE, NEET, CUET, CAT, CLAT, BITSAT",
      eligibility: "Class 12 / graduation + qualifying entrance score",
      process: "Apply via exam counselling or university portals",
    },
    cost: { tuition: "₹0.3L – ₹18L / yr", living: "₹1.5L – ₹4L / yr", city: "Metros higher; tier-2 cheaper" },
    intakes: ["July–August (main)", "January (select programs)"],
    popularCities: ["Mumbai", "Bengaluru", "Delhi", "Hyderabad"],
    postStudy: "Strong campus placements; growing startup and tech ecosystem.",
  },
  {
    name: "United Kingdom",
    flag: "🇬🇧",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?q=85&w=1200",
    tagline: "World-class universities and 1–2 year master's degrees.",
    visa: {
      type: "Student visa (Route)",
      processing: "3–8 weeks",
      funds: "~£1,334/month living funds (outside London)",
      work: "20 hrs/week during term; full-time on breaks",
    },
    cost: { tuition: "₹18L – ₹40L / yr", living: "₹12L – ₹18L / yr", city: "London highest; North cheaper" },
    intakes: ["September (main)", "January (limited)"],
    popularCities: ["London", "Manchester", "Edinburgh", "Birmingham"],
    postStudy: "Graduate Route: 2 years post-study work (3 for PhD).",
  },
  {
    name: "United States",
    flag: "🇺🇸",
    image: "https://images.unsplash.com/photo-1501466044931-62695aada8e9?q=85&w=1200",
    tagline: "Largest choice of programs and research funding worldwide.",
    visa: {
      type: "F-1 Student visa",
      processing: "4–10 weeks (interview required)",
      funds: "Proof of full first-year cost + living",
      work: "On-campus 20 hrs/week; CPT/OPT for internships",
    },
    cost: { tuition: "₹25L – ₹55L / yr", living: "₹12L – ₹20L / yr", city: "Coasts pricier than Midwest" },
    intakes: ["Fall (Aug–Sep, main)", "Spring (Jan)"],
    popularCities: ["New York", "Boston", "San Francisco", "Chicago"],
    postStudy: "OPT: up to 12 months (36 for STEM).",
  },
  {
    name: "Canada",
    flag: "🇨🇦",
    image: "https://images.unsplash.com/photo-1517935706615-2717063c2225?q=85&w=1200",
    tagline: "Affordable, immigration-friendly and high quality of life.",
    visa: {
      type: "Study Permit",
      processing: "4–12 weeks (SDS faster)",
      funds: "GIC of CAD 20,635 + first-year tuition",
      work: "Up to 24 hrs/week off-campus during term",
    },
    cost: { tuition: "₹15L – ₹35L / yr", living: "₹10L – ₹16L / yr", city: "Toronto/Vancouver highest" },
    intakes: ["Fall (Sep, main)", "Winter (Jan)", "Summer (May)"],
    popularCities: ["Toronto", "Vancouver", "Montreal", "Waterloo"],
    postStudy: "PGWP: up to 3 years post-study work.",
  },
  {
    name: "Australia",
    flag: "🇦🇺",
    image: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=85&w=1200",
    tagline: "Strong research, sunny lifestyle and generous work rights.",
    visa: {
      type: "Student visa (Subclass 500)",
      processing: "4–8 weeks",
      funds: "~AUD 29,710/yr living funds",
      work: "48 hrs/fortnight during term",
    },
    cost: { tuition: "₹18L – ₹38L / yr", living: "₹12L – ₹18L / yr", city: "Sydney/Melbourne highest" },
    intakes: ["February (main)", "July"],
    popularCities: ["Melbourne", "Sydney", "Brisbane", "Perth"],
    postStudy: "Temporary Graduate visa: 2–4 years.",
  },
  {
    name: "Germany",
    flag: "🇩🇪",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?q=85&w=1200",
    tagline: "Low or no tuition at top public engineering universities.",
    visa: {
      type: "National (D) Student visa",
      processing: "6–12 weeks",
      funds: "Blocked account ~€11,904/yr",
      work: "120 full / 240 half days per year",
    },
    cost: { tuition: "₹0 – ₹4L / yr (public)", living: "₹8L – ₹12L / yr", city: "Munich priciest" },
    intakes: ["Winter (Oct, main)", "Summer (Apr)"],
    popularCities: ["Munich", "Berlin", "Aachen", "Stuttgart"],
    postStudy: "18-month job-seeker residence permit.",
  },
];

export const getCountry = (slug) => COUNTRY_GUIDES.find((c) => slugifyCountry(c.name) === slug);
